import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  emptyList1g2z5xcrvp2zy as emptyList,
  get_lastIndex1yw0x4k50k51w as get_lastIndex,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  first58ocm7j58k3q as first,
  last1vo29oleiqj36 as last,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { Companion_getInstancehe53gw4v5mqu as Companion_getInstance } from './URLProtocol.mjs';
import { _Char___init__impl__6a9atx2yltdocdrxs4d as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  indexOf1xbs558u7wr52 as indexOf,
  indexOfAny2ijjuuzpljsyd as indexOfAny,
} from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { charArrayOf27f4r3dozbrk1 as charArrayOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import {
  substring3saq8ornu0luv as substring,
  substringiqarkczpya5m as substring_0,
} from '../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  get_hostWithPortIfSpecified1w0e2oq2yfcan as get_hostWithPortIfSpecified,
  Urlowwyg1lanrqp as Url,
  appendUserAndPassword2m6va0hoftk5 as appendUserAndPassword,
} from './URLUtils.mjs';
import { STRING_getInstance1ov5zayfui8fl as STRING_getInstance } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptors.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  return Companion_instance;
}
function Url$_get_encodedPath_$ref_fg9j48() {
  return constructCallableReference((p0) => p0.e57(), 1, 0, 209);
}
function Url$_get_encodedQuery_$ref_c7vq1h() {
  return constructCallableReference((p0) => p0.h57(), 1, 0, 210);
}
function Url$_get_encodedUser_$ref_3lb9bi() {
  return constructCallableReference((p0) => p0.f57(), 1, 0, 211);
}
function Url$_get_encodedPassword_$ref_25ixc2() {
  return constructCallableReference((p0) => p0.g57(), 1, 0, 212);
}
function Url$_get_encodedFragment_$ref_itp7pv() {
  return constructCallableReference((p0) => p0.i57(), 1, 0, 213);
}
var UrlClass;
function Url_0() {
  if (UrlClass === VOID) {
    class $ {
      constructor(protocol, host, specifiedPort, pathSegments, parameters, fragment, user, password, trailingQuery, urlString) {
        this.n55_1 = host;
        this.o55_1 = specifiedPort;
        this.p55_1 = parameters;
        this.q55_1 = fragment;
        this.r55_1 = user;
        this.s55_1 = password;
        this.t55_1 = trailingQuery;
        this.u55_1 = urlString;
        var containsArg = this.o55_1;
        // Inline function 'kotlin.require' call
        if (!(0 <= containsArg ? containsArg <= 65535 : false)) {
          var message = 'Port must be between 0 and 65535, or 0 if not set. Provided: ' + this.o55_1;
          throw IllegalArgumentException().n2(toString(message));
        }
        this.v55_1 = pathSegments;
        this.w55_1 = pathSegments;
        var tmp = this;
        tmp.x55_1 = lazy(() => {
          var tmp;
          if (pathSegments.n1()) {
            return emptyList();
          }
          var tmp_0;
          var tmp_1;
          // Inline function 'kotlin.text.isEmpty' call
          var this_0 = first(pathSegments);
          if (charSequenceLength(this_0) === 0) {
            tmp_1 = pathSegments.q2() > 1;
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            tmp_0 = 1;
          } else {
            tmp_0 = 0;
          }
          var start = tmp_0;
          var tmp_2;
          // Inline function 'kotlin.text.isEmpty' call
          var this_1 = last(pathSegments);
          if (charSequenceLength(this_1) === 0) {
            tmp_2 = get_lastIndex(pathSegments);
          } else {
            tmp_2 = get_lastIndex(pathSegments) + 1 | 0;
          }
          var end = tmp_2;
          return pathSegments.b3(start, end);
        });
        this.y55_1 = protocol;
        var tmp_0 = this;
        var tmp0_elvis_lhs = this.y55_1;
        tmp_0.z55_1 = tmp0_elvis_lhs == null ? Companion_getInstance().k56_1 : tmp0_elvis_lhs;
        var tmp_1 = this;
        tmp_1.a56_1 = lazy(() => {
          var tmp;
          if (pathSegments.n1()) {
            return '';
          }
          var pathStartIndex = indexOf(this.u55_1, _Char___init__impl__6a9atx(47), this.z55_1.k55_1.length + 3 | 0);
          var tmp_0;
          if (pathStartIndex === -1) {
            return '';
          }
          // Inline function 'kotlin.charArrayOf' call
          var tmp$ret$4 = charArrayOf([_Char___init__impl__6a9atx(63), _Char___init__impl__6a9atx(35)]);
          var pathEndIndex = indexOfAny(this.u55_1, tmp$ret$4, pathStartIndex);
          var tmp_1;
          if (pathEndIndex === -1) {
            return substring(this.u55_1, pathStartIndex);
          }
          return substring_0(this.u55_1, pathStartIndex, pathEndIndex);
        });
        var tmp_2 = this;
        tmp_2.b56_1 = lazy(() => {
          var queryStart = indexOf(this.u55_1, _Char___init__impl__6a9atx(63)) + 1 | 0;
          var tmp;
          if (queryStart === 0) {
            return '';
          }
          var queryEnd = indexOf(this.u55_1, _Char___init__impl__6a9atx(35), queryStart);
          var tmp_0;
          if (queryEnd === -1) {
            return substring(this.u55_1, queryStart);
          }
          return substring_0(this.u55_1, queryStart, queryEnd);
        });
        var tmp_3 = this;
        tmp_3.c56_1 = lazy(() => {
          var pathStart = indexOf(this.u55_1, _Char___init__impl__6a9atx(47), this.z55_1.k55_1.length + 3 | 0);
          var tmp;
          if (pathStart === -1) {
            return '';
          }
          var queryEnd = indexOf(this.u55_1, _Char___init__impl__6a9atx(35), pathStart);
          var tmp_0;
          if (queryEnd === -1) {
            return substring(this.u55_1, pathStart);
          }
          return substring_0(this.u55_1, pathStart, queryEnd);
        });
        var tmp_4 = this;
        tmp_4.d56_1 = lazy(() => {
          var tmp;
          if (this.r55_1 == null) {
            return null;
          }
          var tmp_0;
          // Inline function 'kotlin.text.isEmpty' call
          var this_0 = this.r55_1;
          if (charSequenceLength(this_0) === 0) {
            return '';
          }
          var usernameStart = this.z55_1.k55_1.length + 3 | 0;
          // Inline function 'kotlin.charArrayOf' call
          var tmp$ret$6 = charArrayOf([_Char___init__impl__6a9atx(58), _Char___init__impl__6a9atx(64)]);
          var usernameEnd = indexOfAny(this.u55_1, tmp$ret$6, usernameStart);
          return substring_0(this.u55_1, usernameStart, usernameEnd);
        });
        var tmp_5 = this;
        tmp_5.e56_1 = lazy(() => {
          var tmp;
          if (this.s55_1 == null) {
            return null;
          }
          var tmp_0;
          // Inline function 'kotlin.text.isEmpty' call
          var this_0 = this.s55_1;
          if (charSequenceLength(this_0) === 0) {
            return '';
          }
          var passwordStart = indexOf(this.u55_1, _Char___init__impl__6a9atx(58), this.z55_1.k55_1.length + 3 | 0) + 1 | 0;
          var passwordEnd = indexOf(this.u55_1, _Char___init__impl__6a9atx(64));
          return substring_0(this.u55_1, passwordStart, passwordEnd);
        });
        var tmp_6 = this;
        tmp_6.f56_1 = lazy(() => {
          var fragmentStart = indexOf(this.u55_1, _Char___init__impl__6a9atx(35)) + 1 | 0;
          var tmp;
          if (fragmentStart === 0) {
            return '';
          }
          return substring(this.u55_1, fragmentStart);
        });
      }
      d57() {
        // Inline function 'kotlin.takeUnless' call
        var this_0 = this.o55_1;
        var tmp;
        if (!(this_0 === 0)) {
          tmp = this_0;
        } else {
          tmp = null;
        }
        var tmp0_elvis_lhs = tmp;
        return tmp0_elvis_lhs == null ? this.z55_1.l55_1 : tmp0_elvis_lhs;
      }
      e57() {
        var tmp0 = this.a56_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('encodedPath', 1, tmp, Url$_get_encodedPath_$ref_fg9j48(), null);
        return tmp0.n3();
      }
      h57() {
        var tmp0 = this.b56_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('encodedQuery', 1, tmp, Url$_get_encodedQuery_$ref_c7vq1h(), null);
        return tmp0.n3();
      }
      f57() {
        var tmp0 = this.d56_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('encodedUser', 1, tmp, Url$_get_encodedUser_$ref_3lb9bi(), null);
        return tmp0.n3();
      }
      g57() {
        var tmp0 = this.e56_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('encodedPassword', 1, tmp, Url$_get_encodedPassword_$ref_25ixc2(), null);
        return tmp0.n3();
      }
      i57() {
        var tmp0 = this.f56_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('encodedFragment', 1, tmp, Url$_get_encodedFragment_$ref_itp7pv(), null);
        return tmp0.n3();
      }
      toString() {
        return this.u55_1;
      }
      equals(other) {
        if (this === other)
          return true;
        if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
          return false;
        if (!(other instanceof Url_0()))
          THROW_CCE();
        return this.u55_1 === other.u55_1;
      }
      hashCode() {
        return getStringHashCode(this.u55_1);
      }
    }
    initMetadataForClass($, 'Url', VOID, VOID, VOID, VOID, VOID, {0: UrlSerializer_getInstance});
    UrlClass = $;
  }
  return UrlClass;
}
function get_authority(_this__u8e3s4) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder().l1();
  this_0.m1(get_encodedUserAndPassword(_this__u8e3s4));
  this_0.m1(get_hostWithPortIfSpecified(_this__u8e3s4));
  return this_0.toString();
}
var UrlSerializerClass;
function UrlSerializer() {
  if (UrlSerializerClass === VOID) {
    class $ {
      constructor() {
        UrlSerializer_instance = this;
        this.j57_1 = PrimitiveSerialDescriptor('io.ktor.http.Url', STRING_getInstance());
      }
      g1m() {
        return this.j57_1;
      }
      i1m(decoder) {
        return Url(decoder.s1q());
      }
      k57(encoder, value) {
        encoder.c1s(value.toString());
      }
      h1m(encoder, value) {
        return this.k57(encoder, value instanceof Url_0() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'UrlSerializer', VOID, VOID, [KSerializer()]);
    UrlSerializerClass = $;
  }
  return UrlSerializerClass;
}
var UrlSerializer_instance;
function UrlSerializer_getInstance() {
  if (UrlSerializer_instance === VOID)
    new (UrlSerializer())();
  return UrlSerializer_instance;
}
function get_encodedUserAndPassword(_this__u8e3s4) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder().l1();
  appendUserAndPassword(this_0, _this__u8e3s4.f57(), _this__u8e3s4.g57());
  return this_0.toString();
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Url_0 as Url1652zsz51o0h6,
  get_authority as get_authority2s3hk87lssumy,
};
//endregion

//# sourceMappingURL=Url.mjs.map
